import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/info',
  name: 'Info',
  component: function component() {
    return import(/* webpackChunkName: "publico" */'./pages/Info');
  },
  meta: {
    titulo: 'Informações',
    precisaAutenticacao: false,
    cabecalho: true,
    rodape: false
  }
}];